import React from "react";
import { Typography } from "@material-ui/core";

const VerifyPasswordInfo = () => (
    <Typography variant="h6">
      Passwords must match
    </Typography>
);
export default VerifyPasswordInfo;
